import type { ActionHandlers, IGroupNCI } from "../../types/types";
import { initialNetCarbonIntensitySate } from "../InitialStates/NetCarbonIntensityState";
import { createReducer } from "../ReducerFunction";

const actionHandlers: ActionHandlers = {
  setNetCarbonIntensity: (_state: IGroupNCI[], payload: IGroupNCI[]) => {
    // ==================================================================================
    // BASELINE NCI PRESERVATION STRATEGY - CRITICAL FOR EVP SWITCHING
    // ==================================================================================
    //
    // PROBLEM SOLVED: NetCarbonIntensity data was getting corrupted during calculations
    // when users switched between EVPs, causing baseline values to become -0 or undefined
    //
    // ROOT CAUSE: T&S Products calculations would overwrite REPORTED_GROUP_NCI with
    // calculated values, corrupting the data for subsequent SLMT calculations
    //
    // SOLUTION: Immediately preserve original REPORTED_GROUP_NCI values in a separate
    // ORIGINAL_BASELINE_NCI property when API data first loads, before any calculations
    // can corrupt the data
    //
    // BENEFITS:
    // - EVP switching works in any order (T&S Products ↔ SLMT ↔ DR Power)
    // - Original baseline values never get overwritten
    // - Dynamic and maintainable (no hardcoded fallback values)
    // - Consistent across all calculation flows
    //
    // USAGE: All NCI Impact calculations now use item.ORIGINAL_BASELINE_NCI instead
    // of item.REPORTED_GROUP_NCI to ensure clean baseline values
    // ==================================================================================

    const preservedData = payload.map((item) => ({
      ...item,
      ORIGINAL_BASELINE_NCI: item.REPORTED_GROUP_NCI, // Preserve the original baseline immediately
    }));

    return preservedData;
  },
};
export const netCarbonIntensityReducer = createReducer(
  initialNetCarbonIntensitySate,
  actionHandlers
);
